import { TextInput as MantineTextInput } from '@mantine/core'
import type { UseFormRegisterReturn } from 'react-hook-form'

interface NumericInputProps {
  label: string
  placeholder?: string
  required?: boolean
  error?: string
  helperText?: string
  leftSection?: React.ReactNode
  rightSection?: React.ReactNode
  className?: string
  disabled?: boolean
  min?: number
  max?: number
  step?: number
  register?: UseFormRegisterReturn
  value?: number
  onChange?: (value: number) => void
}

export function NumericInput({
  label,
  placeholder,
  required = false,
  error,
  helperText,
  leftSection,
  rightSection,
  className = '',
  disabled = false,
  min,
  max,
  step = 1,
  register,
  value,
  onChange,
}: NumericInputProps) {
  const inputProps = register
    ? { ...register }
    : {
        value: value?.toString() || '',
        onChange: onChange
          ? (e: React.ChangeEvent<HTMLInputElement>) => {
              const numValue = parseFloat(e.target.value)
              if (!isNaN(numValue)) {
                onChange(numValue)
              }
            }
          : undefined,
      }

  return (
    <div className={`space-y-1 ${className}`}>
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>

      <MantineTextInput
        {...inputProps}
        placeholder={placeholder}
        disabled={disabled}
        type="number"
        min={min}
        max={max}
        step={step}
        leftSection={leftSection}
        rightSection={rightSection}
        error={error}
        description={helperText}
        radius="md"
        size="md"
        className="w-full"
        styles={{
          input: {
            backgroundColor: '#F5F5F7',
            border: 'none',
          },
          error: {
            fontSize: 10,
          },
        }}
      />
    </div>
  )
}
